// NOTE:
// - As a best practice, components should not directly consume `new Date()` or `I18n.moment.portalTz()`
// - These selectors exist to keep components (and the utilities they consume) pure & testable
// - currentDate and currentDatePortalTz are set when the page loads and are guaranteed to exist
export const getCurrentDate = state => state.date.currentDate;

// Returns the current date adjusted for Portal's timezone
export const getCurrentDatePortalTz = state => state.date.currentDateInPortalTz;